module.exports = __webpack_public_path__ + "img/whatsapp.fd0468f8.png";